import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import axios from "axios";

const OtherCertificates = () => {
  const [formData, setFormData] = useState({
    name: "",
    parent: "",
    school: "",
    startYear: "",
    endYear: "",
    certificateType: "bonafide",
  });

  const [schoolData, setSchoolData] = useState(null);
  const [logo, setSchoolLogo] = useState(null);

  // 🔹 Page size + orientation state
  const [pageSize, setPageSize] = useState("a4");
  const [orientation, setOrientation] = useState("portrait"); // 👈 new
  const [customSize, setCustomSize] = useState({ w: 210, h: 297 });

  // 🔹 Fetch logo
  useEffect(() => {
    fetch("http://localhost/epro_API/api/logo/getLogo.php")
      .then(res => res.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onloadend = () => {
          setSchoolLogo(reader.result); // ✅ Base64 Data URL
        };
        reader.readAsDataURL(blob);
      });
  }, []);

  // 🔹 Fetch school details
  useEffect(() => {
    axios.get("http://localhost/epro_API/api/school/schoolDetail.php")
      .then((res) => {
        const school = res.data.data[0];
        setSchoolData(school);
        setFormData((prev) => ({ ...prev, school: school.school_name }));
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const generatePDF = () => {
    let format;

    if (pageSize === "custom") {
      format = [customSize.w, customSize.h]; // [width, height] in mm
    } else {
      format = pageSize; // "a4", "a5", "legal"
    }

    // 👇 pass orientation here
    const doc = new jsPDF({ orientation, unit: "mm", format });

    // 📌 Border
    doc.setLineWidth(1);
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

    // 📌 Logo
    if (logo) {
      doc.addImage(logo, "PNG", pageWidth / 2 - 15, 15, 30, 30);
    }

    // 📌 Heading
    doc.setFont("times", "bold");
    doc.setFontSize(20);
    const heading =
      formData.certificateType === "bonafide"
        ? "BONAFIDE CERTIFICATE"
        : "CHARACTER CERTIFICATE";
    doc.text(heading, pageWidth / 2, 60, { align: "center" });

    // 📌 Body
    doc.setFont("times", "normal");
    doc.setFontSize(13);

    let bodyText = "";
    if (formData.certificateType === "bonafide") {
      bodyText = `This is to certify that Mr./Ms. ${formData.name}, son/daughter of ${formData.parent}, 
is a bonafide student of ${formData.school}. He/She has been studying in this school 
from ${formData.startYear} to ${formData.endYear}. He/She bears a good moral character.`;
    } else {
      bodyText = `This is to certify that Mr./Ms. ${formData.name}, son/daughter of ${formData.parent}, 
was a student of ${formData.school} from ${formData.startYear} to ${formData.endYear}. 
During this period, his/her conduct and character have been found satisfactory.`;
    }

    doc.text(bodyText, 20, 90, { maxWidth: pageWidth - 40, align: "justify" });

    // 📌 Footer
    const currentDate = new Date().toLocaleDateString();
    doc.text(`Date: ${currentDate}`, 20, pageHeight - 40);
    doc.text("Seal", 50, pageHeight - 20, { align: "center" });
    doc.text("Principal", pageWidth - 50, pageHeight - 20, { align: "center" });

    // Save
    doc.save(`${formData.certificateType}_certificate.pdf`);
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h1 className="text-xl font-bold mb-4">🎓 Certificate Generator</h1>

      {!schoolData ? (
        <p>Loading school data...</p>
      ) : (
        <>
          {logo && <img src={logo} alt="School Logo" width="100" />}

          {/* Certificate Type */}
          <select
            name="certificateType"
            value={formData.certificateType}
            onChange={handleChange}
            className="w-full p-2 border rounded mb-3"
          >
            <option value="bonafide">Bonafide Certificate</option>
            <option value="character">Character Certificate</option>
          </select>

          {/* Student Info */}
          <input
            type="text"
            name="name"
            placeholder="Student Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded mb-3"
          />
          <input
            type="text"
            name="parent"
            placeholder="Parent's Name"
            value={formData.parent}
            onChange={handleChange}
            className="w-full p-2 border rounded mb-3"
          />
          <input
            type="text"
            name="school"
            value={formData.school}
            disabled
            className="w-full p-2 border rounded mb-3 bg-gray-100"
          />

          <div className="flex gap-2 mb-3">
            <input
              type="text"
              name="startYear"
              placeholder="Start Year"
              value={formData.startYear}
              onChange={handleChange}
              className="w-1/2 p-2 border rounded"
            />
            <input
              type="text"
              name="endYear"
              placeholder="End Year"
              value={formData.endYear}
              onChange={handleChange}
              className="w-1/2 p-2 border rounded"
            />
          </div>

          {/* Page Size Selector */}
          <select
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
            className="w-full p-2 border rounded mb-3"
          >
            <option value="a4">A4</option>
            <option value="a5">A5</option>
            <option value="legal">Legal</option>
            <option value="custom">Custom</option>
          </select>

          {pageSize === "custom" && (
            <div className="flex gap-2 mb-3">
              <input
                type="number"
                placeholder="Width (mm)"
                value={customSize.w}
                onChange={(e) =>
                  setCustomSize({ ...customSize, w: +e.target.value })
                }
                className="w-1/2 p-2 border rounded"
              />
              <input
                type="number"
                placeholder="Height (mm)"
                value={customSize.h}
                onChange={(e) =>
                  setCustomSize({ ...customSize, h: +e.target.value })
                }
                className="w-1/2 p-2 border rounded"
              />
            </div>
          )}

          {/* Orientation Selector */}
          <select
            value={orientation}
            onChange={(e) => setOrientation(e.target.value)}
            className="w-full p-2 border rounded mb-3"
          >
            <option value="portrait">Portrait</option>
            <option value="landscape">Landscape</option>
          </select>

          {/* Generate PDF */}
          <button
            onClick={generatePDF}
            className="w-full bg-blue-500 text-white p-2 rounded"
          >
            Generate Certificate
          </button>
        </>
      )}
    </div>
  );
};

export default OtherCertificates;
